/**
 * Utility for managing Pet Info Callout responses in localStorage
 * Stores ANY interaction with the callout: answer selections (yes/no/unsure) OR dismissal (X button)
 * Responses are tracked per dog set — the callout reappears if the user's dogs change
 */

import { getItem, removeItem, setItem } from '@rover/utilities/localStorage.client';

import { createPetInfoCalloutStorage } from './petInfoCalloutStorage.common';

export const STORAGE_KEY = 'roverPetInfoCalloutResponses';

export type {
  DogSet,
  PetInfoCalloutResponse,
  CalloutResponses,
} from './petInfoCalloutStorage.common';
export { dogSetsMatch } from './petInfoCalloutStorage.common';

const {
  getCalloutResponse,
  hasRespondedToCallout,
  storeCalloutResponse,
  clearCalloutResponse,
  clearAllCalloutResponses,
} = createPetInfoCalloutStorage({
  getItem: () => getItem(STORAGE_KEY),
  setItem: (value) => setItem(STORAGE_KEY, value),
  removeItem: () => removeItem(STORAGE_KEY),
});

export {
  getCalloutResponse,
  hasRespondedToCallout,
  storeCalloutResponse,
  clearCalloutResponse,
  clearAllCalloutResponses,
};
